import Button from '@/components/shared/Button/Button';
import { ContentStatus } from '@addmile/backend-client';

import JourneyStatusSelect from '../../JourneyStatusSelect/JourneyStatusSelect';

interface EditorHeaderProps {
  title: string;
  counts: string;
  status: ContentStatus;
  canSave: boolean;
  isSaving: boolean;
  onBack: () => void;
  onStatusChange: (status: ContentStatus) => void;
  onSave: () => void;
}

const EditorHeader = ({
  title,
  counts,
  status,
  canSave,
  isSaving,
  onBack,
  onStatusChange,
  onSave,
}: EditorHeaderProps) => (
  <div className="flex items-center justify-between gap-4 rounded-2xl bg-white-100 px-5 py-4">
    <div className="flex items-center gap-4 min-w-0">
      <button type="button" onClick={onBack} className="shrink-0" title="Back to journeys">
        <img src="/icons/arrow-left.svg" alt="back" />
      </button>
      <div className="min-w-0">
        <h1 className="text-2xl font-bold text-neutral-90 truncate">{title}</h1>
        <p className="text-sm text-neutral-50">{counts}</p>
      </div>
    </div>
    <div className="flex items-center gap-4 shrink-0">
      <JourneyStatusSelect label="Status" status={status} onChange={onStatusChange} withHints />
      <Button
        label={isSaving ? 'Saving...' : 'Save'}
        className="!w-28"
        disabled={!canSave || isSaving}
        prefixIcon={<img src="/icons/save.svg" alt="" />}
        onClick={onSave}
      />
    </div>
  </div>
);

export default EditorHeader;
